import {useQuery} from '@tanstack/react-query';
import {AxiosError, AxiosResponse} from 'axios';
import {AxiosErrorToast} from '../general/ReusableFunctions';
import {IApiDataResponse} from '../../dto/API.dto';
import {IDeviceInstallWithStations} from '../../dto/DeviceInstallation.dto';
import axiosInstance from '../../axiosConfig';

export const getDeviceInstallationsApiPath = (taskId: number) =>
  `/v1/task/${taskId}/device-installation`;

const getDeviceInstallations = (taskId: number) => {
  return axiosInstance
    .get(getDeviceInstallationsApiPath(taskId))
    .then(
      (
        response: AxiosResponse<IApiDataResponse<IDeviceInstallWithStations[]>>,
      ) => {
        return response.data.data;
      },
    )
    .catch((error: AxiosError) => {
      AxiosErrorToast(error, 'Error in listing devices');
      throw error;
    });
};

export const useRqListDeviceInstallations = (
  taskId: number,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: [getDeviceInstallationsApiPath(taskId)],
    queryFn: () => getDeviceInstallations(taskId),
    refetchOnWindowFocus: false,
    retry: false,
    enabled: enabled,
  });
};
